// form配置文件
export default {
  labelWidth: 90,
  span: 12,
  xsSpan: 24
}